import {
    PropertyFileForm,
    PropertyFormValues,
    PropertyManualForm,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { getFeatureFlags } from 'core/flow-control';
import { buildCSV, createCsvData } from 'utils/create-csv/create-csv';
import Papa from 'papaparse';
import { downloadFile } from 'API/common/download-file-service/download-file-service';
import { useCallback } from 'react';
import { generateCsvFileName } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/utils';

export const useGetSubmitPropertyForm = () => {
    return useCallback((data: PropertyFormValues) => {
        const { dev_download_preresolver_results_ff } = getFeatureFlags();
        const fileName = generateCsvFileName({ name: 'resolver', withTimeFormat: true });
        const files: File[] = [];
        if (data.inputType === 'manual') {
            // Create csv file from manual input
            const csv = buildCSV(
                ['name', 'address', 'zip_code'],
                (data as PropertyManualForm).properties.map(({ name, address, zip_code = '' }) => [
                    name,
                    address,
                    zip_code,
                ]),
            );
            files.push(new File([createCsvData(csv)], fileName));
        } else {
            const csv = Papa.unparse(data.parsedData.data);
            const newCSVFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            files.push(new File([newCSVFile], fileName));
            const dataFile = (data as PropertyFileForm).file[0];
            if (dataFile) {
                files.push(dataFile?.file);
            }

            if (dev_download_preresolver_results_ff) {
                // Temporary for QA purposes
                downloadFile(newCSVFile, 'export.csv', true);
            }
        }
    }, []);
};
